//
//
//
//
//
//

import request from '@/utils/request';
export default {
  name: 'clearCache',
  data: function data() {
    return {};
  },
  methods: {
    handleClearCache: function handleClearCache() {
      var _this = this;
      request({
        url: '/system/cache/clear',
        method: 'delete'
      }).then(function (res) {
        _this.msgSuccess(res.data);
        location.reload();
      });
    }
  }
};